import Smartphones from 'Reports/views/KeyFigures/containers/Smartphones'
import Tablets from 'Reports/views/KeyFigures/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const KeyFiguresView = getCurrentDeviceView(Smartphones, Tablets)

export default KeyFiguresView
